import { Popover } from '@mui/material';

import { CommonReasons } from '@modules/ContactManager/components/Header/interfaces';

import { ConditionsPopUp } from './ConditionsPopup';
import { ReasonsPopUp } from './ReasonsPopup';

interface IReasonsPopoverProps {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  conditions: boolean;
  handleClose: () => void;
  reasons?: CommonReasons[];
  handleCheckboxChange: (item: CommonReasons, checked: boolean) => void;
  handleResolveConditions: (item: CommonReasons, checked: boolean, isLC: boolean, isLP: boolean, isConditionLp: boolean) => void;
  loading: boolean;
}

export const ReasonsPopover = ({
  open,
  anchorEl,
  conditions,
  handleClose,
  reasons = [],
  handleCheckboxChange,
  handleResolveConditions,
  loading,
}: IReasonsPopoverProps) => {
  return (
    <Popover
      id="simple-popover"
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          width: '500px',
          height: 'auto',
          maxHeight: '600px',
          padding: '0 0 14px 14px'
        },
      }}
      onClose={handleClose}
    >
      {!conditions ?
        <ReasonsPopUp
          reasons={reasons}
          handleCheckboxChange={handleCheckboxChange}
          loading={loading}
          onClose={handleClose}
        />
        : <ConditionsPopUp
          reasons={reasons}
          loading={loading}
          handleResolveConditions={handleResolveConditions}
          onClose={handleClose}
        />
      }
    </Popover>
  );
};